import React, { useEffect, useState } from "react";
import { Col, Container, Input, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import {
  addPropertyLabel,
  fetchPropertyLabels,
  PropertyLabel,
  putPropertyLabel,
  removePropertyLabel,
} from "../../services/PropertyLabelsServices";

const showError = () =>
  toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
    position: toast.POSITION.BOTTOM_CENTER,
    pauseOnHover: false,
  });

const showSuccess = (message: string) =>
  toast(message, {
    position: toast.POSITION.BOTTOM_CENTER,
    pauseOnHover: false,
  });

function PropertyLabels() {
  const [loading, setLoading] = useState(false);
  const [labels, setLabels] = useState<PropertyLabel[]>([]);
  const [names, setNames] = useState<{ [id: number]: string }>({});
  const [newName, setNewName] = useState("");

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      const response = await fetchPropertyLabels();
      const result: PropertyLabel[] = response.data.data;
      setLabels(result);
      setNames(
        result.reduce((acc, item) => ({ ...acc, [item.id]: item.name }), {})
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showError();
    }
  };

  const add = async () => {
    if (!newName.trim()) {
      toast.error(`Ingrese un nombre para la etiqueta`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
      return;
    }
    try {
      setLoading(true);
      await addPropertyLabel(newName.trim());
      setNewName("");
      showSuccess(`Etiqueta creada con éxito`);
      await fetch();
    } catch (error) {
      setLoading(false);
      showError();
    }
  };

  const save = async (item: PropertyLabel) => {
    const name = (names[item.id] || "").trim();
    if (!name) {
      toast.error(`El nombre no puede quedar vacío`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
      return;
    }
    try {
      setLoading(true);
      await putPropertyLabel(item.id, name);
      showSuccess(`Etiqueta actualizada con éxito`);
      await fetch();
    } catch (error) {
      setLoading(false);
      showError();
    }
  };

  const remove = async (item: PropertyLabel) => {
    if (
      !window.confirm(
        `¿Eliminar la etiqueta "${item.name}"? Las propiedades que la usan quedarán sin etiqueta.`
      )
    ) {
      return;
    }
    try {
      setLoading(true);
      await removePropertyLabel(item.id);
      showSuccess(`Etiqueta eliminada con éxito`);
      await fetch();
    } catch (error) {
      setLoading(false);
      showError();
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content" id="PropertyLabels">
        <Container fluid={true}>
          <Breadcrumb title="Etiquetas" breadcrumbItem="Etiquetas" />
          <Row>
            <Col md={6}>
              <h5>Nueva etiqueta</h5>
              <div className="d-flex mb-4">
                <Input
                  value={newName}
                  placeholder="Ej: Vendida"
                  onChange={(e) => setNewName(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && add()}
                />
                <button
                  className="btn btn-primary waves-effect waves-light ms-2"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => add()}
                >
                  Agregar
                </button>
              </div>

              <h5>Etiquetas</h5>
              {labels.map((item) => (
                <div className="d-flex mb-2" key={item.id}>
                  <Input
                    value={names[item.id] ?? ""}
                    onChange={(e) =>
                      setNames({ ...names, [item.id]: e.target.value })
                    }
                  />
                  <button
                    className="btn btn-primary waves-effect waves-light ms-2"
                    disabled={names[item.id] === item.name}
                    onClick={() => save(item)}
                  >
                    Guardar
                  </button>
                  <button
                    className="btn btn-danger waves-effect waves-light ms-2"
                    onClick={() => remove(item)}
                  >
                    Eliminar
                  </button>
                </div>
              ))}
              {!labels.length && !loading ? (
                <p className="text-muted">No hay etiquetas creadas</p>
              ) : null}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default PropertyLabels;
